// Dependencies
import _ from 'lodash';

// Types
import { Types } from '../utils/types';

const useConditionalLogic = (fieldValues: any) => {

    const checkCondition = ( {name, operator, value}: Types.Condition ) => {

        if ( ! ( name in fieldValues ) ) {
            return false;
        }

        switch ( operator ) {

            case '==':
                if ( ( fieldValues[ name ] === value ) ) {
                    return true;
                }
                break;

            case '!=':
                if ( ( fieldValues[ name ] !== value ) ) {
                    return true;
                }
                break;

            case 'IN':
                if ( (_.isArray( fieldValues[ name ] ) && fieldValues[ name ].includes( value ) ) ) {
                    return true;
                }
                break;

            case 'NOT IN':
                if ( (_.isArray( fieldValues[ name ] ) && ! fieldValues[ name ].includes( value ) ) ) {
                    return true;
                }
                break;

        }

        return false;

    } 

    const checkConditions = ( (conditions: Types.Condition[] | undefined, operator: 'AND' | 'OR' = 'AND'): boolean => {

        if ( _.isUndefined( conditions ) ) {
            return true;
        }

        let validConditionsCount: number = 0;
        
        for ( const condition of conditions ) {

            if ( checkCondition( condition ) ) {
                validConditionsCount++;
            }
            
        }

        switch ( operator ) {

            case 'AND':
                return validConditionsCount === conditions.length;
            case 'OR':
                return validConditionsCount > 0;
        }

    })

    return [checkConditions];

}

export default useConditionalLogic; 